export const OperacionLCSLHPTITablaValorFields = {
    CodOperacionLCSLHPTITablaValor: 'codOperacionLCSLHPTITablaValor',
    IdOperacionLCSLHPTI: 'idOperacion',
    CodInstrumento: 'codInstrumento',
    DescInstrumento: 'descInstrumento',
    CodOperacionTipo: 'codOperacionTipo',
    DescOperacionTipo: 'descOperacionTipo',
    Valor: 'valor',
    Orden: 'orden',
    PermiteEditarInstrumento: 'permiteEditarInstrumento',
    TipoSelector: 'tipoSelector',
    Agrupacion: 'descAgrupacion',
} as const

export const OperacionLCSLHPTIFields = {
    CodOperacionLCSLHPTI: 'idOperacionLCSLHPTI',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodUnidadNegocio: 'codUnidadNegocio',
    DescUnidadNegocio: 'descUnidadNegocio',
    CodSectorComercial: 'codSectorComercial',
    DescSectorComercial: 'descSectorComercial',

    FechaSolicitud: 'fechaSolicitud',
    FechaVencimiento: 'fechaVencimiento',
    CodEstado: 'codEstado',
    DescEstado: 'descEstado',
    Observaciones: 'observaciones',

    TablaValores: 'tablaValores',

    FechaAprobacion: 'fechaAprobacion',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta',
    IdUsuarioUltMod: 'idUsuarioUltMod',
    NombreUsuarioUltMod: 'nombreUsuarioUltMod',
    ApellidoUsuarioUltMod: 'apellidoUsuarioUltMod',
    MailUsuarioUltMod: 'mailUsuarioUltMod',
    EstadoFinalizado: 'estadoFinalizado',
    IdMensaje: 'idMensaje',
    PermiteEditarOperacion: 'permiteEditarOperacion',
    PermiteEliminarOperacion: 'permiteEliminarOperacion',
} as const